module.exports = __webpack_public_path__ + "static/media/mmm-thumbsup.ced2b657.svg";